import Vue from 'vue'
import VueRouter from 'vue-router'
import CardKey from '../views/CardKey.vue'
import CitySelector from '../views/CitySelector.vue'
import Home from '../views/Home.vue'
import GoodsList from '../views/GoodsList.vue'
import GoodsDetail from '../views/GoodsDetail.vue'
import OrderDetail from '../views/OrderDetail.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/cardkey',
  },
  {
    path: '/cardkey',
    name: 'CardKey',
    component: CardKey,
  },
  {
    path: '/city-list',
    name: 'CitySelector',
    component: CitySelector,
  },
  {
    path: '/shop-list',
    name: 'Home',
    component: Home,
  },
  {
    path: '/goods-list',
    name: 'GoodsList',
    component: GoodsList,
  },
  {
    path: '/goods-detail',
    name: 'GoodsDetail',
    component: GoodsDetail,
  },
  {
    path: '/order-detail',
    name: 'OrderDetail',
    component: OrderDetail,
  },
];

const router = new VueRouter({
  routes,
});

export default router; 